import { createEditButton } from '../../../../components'
import { UpsertDeviceTypeModal } from '../UpsertDeviceType/UpsertDeviceTypeModal'

export const DeviceTypeEditButton = createEditButton(UpsertDeviceTypeModal, 'thing_types')
